import { render, staticRenderFns } from "./MultiselectBar.vue?vue&type=template&id=16b954f0&"
import script from "./MultiselectBar.vue?vue&type=script&lang=js&"
export * from "./MultiselectBar.vue?vue&type=script&lang=js&"
import style0 from "./MultiselectBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports